import {
  BottomSheet,
  BottomSheetContent,
  SettingsList,
  SettingsRow,
  Stack,
} from '@relay-towing/ui';
import { Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { CompanyField } from './CompanyField';
import { DutyStatusField } from './DutyStatusRow';

export interface PresenceMenuProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * What the presence pill opens: the duty status, for a driver whose role lets
 * them set it, and the company, for someone in more than one, then
 * Settings. Everything else is in the Functions and
 * Operations tabs.
 */
export function PresenceMenu({ open, onOpenChange }: PresenceMenuProps) {
  const navigate = useNavigate();

  const go = (path: string) => {
    onOpenChange(false);
    navigate(path);
  };

  return (
    <BottomSheet open={open} onOpenChange={onOpenChange}>
      <BottomSheetContent title="Menu">
        {/* What you are set to, then room, then where the rest is: two
            things, not one list. */}
        <Stack gap={6}>
          <Stack gap={4}>
            <DutyStatusField />
            <CompanyField onSwitched={() => onOpenChange(false)} />
          </Stack>
          <SettingsList>
            <SettingsRow
              label="Settings"
              icon={Settings}
              onClick={() => go('/settings')}
            />
          </SettingsList>
        </Stack>
      </BottomSheetContent>
    </BottomSheet>
  );
}
